import { render } from "./Dashboard.vue?vue&type=template&id=ed6d605c&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=ed6d605c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed6d605c"

export default script